module.exports = __webpack_public_path__ + "img/viewPictureWhite.87c52d9c.svg";